import Utils from 'helpers/Utils';
import GPlacesHelper from 'helpers/GPlacesHelper';
import DataProvider from './_base/DataProvider';
import _ from 'underscore';

export default class GPlacesProvider extends DataProvider {
  /**
   * @class GPlacesProvider
   * @classdesc This is a data provider from Google Places
   * @memberof core.layers.dataProviders
   * @constructs
   * @extends DataProvider
   * @param {object} map - The map on which the Google Places will be loaded
   * @param {object} options - The options to specify the search
   */
  constructor(options) {
    super();
    //The provider doesn't load feature if it is not visible in a certain level zoom
    options.minZoom = options.minZoom ? options.minZoom : 1;
    //This option is to avoid several requests in a short time
    options.searchDelay = options.searchDelay ? options.searchDelay : 100;
    this.options = options;
    this.widget = options.widget;
  }

  /**
   * This method is executed when the layer is activated
   */
  onReady() {
    if (this.options.searchOnce) {
      this._addListenersSearchOnce();
    } else {
      this._addListeners();
    }
    this._checkVisibility();
  }

  /**
   * This method is executed when the layer is removed
   */
  onRemove() {
    google.maps.event.removeListener(this.idleEvent);
    google.maps.event.removeListener(this.zoomChangedEvent);
  }

  /**
   * Every 'idle' on the map does a load in order to find new features
   */
  _addListeners() {
    this.idleEvent = google.maps.event.addListener(this.widget.map, 'idle', () => {
      if (!!this._timeout) {
        clearTimeout(this._timeout);
      }
      this._timeout = setTimeout(() => {
        if (this.options.model.isVisible()) {
          this.load();
        }
      }, this.options.searchDelay);
    });
  }

  /**
   * Every 'idle' on the map does a load in order to find new features
   */
  _addListenersSearchOnce() {
    this.idleEvent = google.maps.event.addListenerOnce(this.widget.map, 'idle', () => {
      if (!!this._timeout) {
        clearTimeout(this._timeout);
      }
      this._timeout = setTimeout(() => {
        this.load();
      }, this.options.searchDelay);
    });
  }

  /**
   * Method to load the source data. Overrides the DataProvider method
   */
  load(options) {
    GPlacesHelper.searchNearby(this.map, _.extend({
      type: this.options.category,
      bounds: this.widget.map.getBounds()
    }, options)).then((results, status) => {
      this.trigger('PROCESS_FEATURES', Utils.convertToGeoJSON(results).features, this);
    });
  }
}



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/dataProviders/GPlacesProvider.js